<mat-dialog-content aria-modal="true" class="d-flex flex-col" role="dialog">
    <div class="flex-row flex-space-between">
        <div>
            <mat-card-header class="p-0">
                <mat-card-title>
                    <h3 class="m-0">Keyboard Shortcuts</h3>
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button (click)="this.dialogRef.close();" (keyup.enter)="this.dialogRef.close();" class="mat-dialog-close"
                    mat-dialog-close mat-icon-button
                    matTooltip="Close Window">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="d-flex flex-col shortcuts">
        <div class="d-flex flex-row align-items-center gap10">
            <div class="d-flex flex-row">
                <img alt="Control Key" class="pr-10" height="50" matTooltip="Control Key"
                     ngSrc="assets/images/ctrl-key.png" width="50">
                <img alt="Shift Key" class="pr-10" height="50" matTooltip="Shift Key"
                     ngSrc="assets/images/shift-key.png" width="50">
                <img alt="Space Key" height="50" matTooltip="Space Key" ngSrc="assets/images/space-key.png" width="50">
            </div>
            Pause/Play Slideshow
        </div>
        <div class="d-flex flex-row align-items-center gap10">
            <div class="d-flex flex-row">
                <img alt="Control Key" class="pr-10" height="50" matTooltip="Control Key"
                     ngSrc="assets/images/ctrl-key.png" width="50">
                <img alt="Shift Key" class="pr-10" height="50" matTooltip="Shift Key"
                     ngSrc="assets/images/shift-key.png" width="50">
                <img alt="Left Arrow Key" height="50" matTooltip="Left Arrow Key"
                     ngSrc="assets/images/left-key.png" width="50">
                <span class="orText">/</span>
                <img alt="Control Key" class="pr-10" height="50" matTooltip="Control Key"
                     ngSrc="assets/images/ctrl-key.png" width="50">
                <img alt="Shift Key" class="pr-10" height="50" matTooltip="Shift Key"
                     ngSrc="assets/images/shift-key.png" width="50">
                <img alt="a Key" height="50" matTooltip="a Key"
                     ngSrc="assets/images/a-key.png" width="50">
            </div>
            Navigate to the memory on the left
        </div>
        <div class="d-flex flex-row align-items-center gap10">
            <div class="d-flex flex-row">
                <img alt="Control Key" class="pr-10" height="50" matTooltip="Control Key"
                     ngSrc="assets/images/ctrl-key.png" width="50">
                <img alt="Shift Key" class="pr-10" height="50" matTooltip="Shift Key"
                     ngSrc="assets/images/shift-key.png" width="50">
                <img alt="Right Arrow Key" height="50"
                     matTooltip="Right Arrow Key"
                     ngSrc="assets/images/right-key.png" width="50">
                <span class="orText">/</span>
                <img alt="Control Key" class="pr-10" height="50" matTooltip="Control Key"
                     ngSrc="assets/images/ctrl-key.png" width="50">
                <img alt="Shift Key" class="pr-10" height="50" matTooltip="Shift Key"
                     ngSrc="assets/images/shift-key.png" width="50">
                <img alt="d Key" height="50" matTooltip="d Key"
                     ngSrc="assets/images/d-key.png" width="50">
            </div>
            Navigate to the memory on the right
        </div>
    </div>

</mat-dialog-content>

